import {Component, OnInit} from '@angular/core';
import {
  RealtorPortalService
} from '../../services/network/realtor-portal.service';
import {ApiAccessService} from '../../services/network/api-access.service';
import {
  ToastSuccessComponent
} from '../../parts/toast-success/toast-success.component';
import {MatSnackBar} from '@angular/material';
import {DialogsService} from '../../services/dialog.service';
import {NewEntity} from '../../models/new-entity';
import {UtilitiesService} from '../../services/utilities.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {
  resetPasswordVisible = false;
  password: string;
  passwordConfirm: string;
  oldPassword: string;
  changingPassword = false;
  webUserInfo: any;
  entity: any;
  loadingEntity = true;
  selectedIndex = 0;
  agentInfo: any;
  savingAgentInfo = false;

  branchSearchName: string;
  branchSearchCity: string;
  searchingForBranch = false;
  branches: any[];
  branchSearchResultVisible = false;
  showBranchSearch = true;
  addOfficeVisible = false;
  newBranch: NewEntity = new NewEntity();
  savingBranch = false;

  isTitleEntity = false;


  constructor(private realtorPortalService: RealtorPortalService,
              private snakbar: MatSnackBar,
              private dialogService: DialogsService) {}

  ngOnInit() { this.refresh(); }

  private refresh(callback: any = null) {
    this.realtorPortalService.getWebUserInfo().then(
        webUserInfo => { this.webUserInfo = webUserInfo; });

    this.realtorPortalService.getWebUserEntityRecord().then(entity => {
      this.entity = entity;
      this.loadingEntity = false;
    });

    this.realtorPortalService.getWebUserExInfo().then(info => {
      this.agentInfo = info;
      if (info) {
        this.isTitleEntity = info.EntityType === 'Closing_Officer' ||
                             info.EntityType === 'Closing_Officer_Coordinator';
      }
      if (callback) {
        callback();
      }
    });
  }



  get canSearchForBranch() {
    return this.branchSearchName && this.branchSearchCity;
  }

  get canSaveBranch() {
    return this.newBranch.Name && this.newBranch.StreetAddress &&
           this.newBranch.City && this.newBranch.State &&
           this.newBranch.ZipCode && this.newBranch.Phone &&
           UtilitiesService.isValidPhoneNumber(this.newBranch.Phone);
  }


  saveNewBranch() {
    this.savingBranch = true;
    this.newBranch.Id = UtilitiesService.newid();

    if (this.isTitleEntity) {
      this.realtorPortalService.saveNewTitleCompany(this.newBranch)
          .then(result => {
            this.setRealEstateBranch(this.newBranch, () => {
              this.savingBranch = false;
              this.newBranch = new NewEntity();
            });
          });
    } else {
      this.realtorPortalService.saveNewBranch(this.newBranch)
          .then(result => {
            this.setRealEstateBranch(this.newBranch, () => {
              this.savingBranch = false;
              this.newBranch = new NewEntity();
            });
          });
    }
  }


  createNewBranch() {
    this.showBranchSearch = false;
    this.addOfficeVisible = true;
    this.newBranch.Name = this.branchSearchName;
    this.newBranch.City = this.branchSearchCity;
  }

  setRealEstateBranch(realEstateBranch, callback: any = null) {
    this.agentInfo.ParentId = realEstateBranch.Id;
    this.saveAgentInfo(callback);
  }

  onStepChange() {
    this.showBranchSearch = true;
    this.branchSearchResultVisible = false;
    this.addOfficeVisible = false;
  }

  searchForBranch() {
    this.searchingForBranch = true;

    if (this.isTitleEntity) {
      this.realtorPortalService.findTitleCompanyByNameAndCity(
                                   this.branchSearchName, this.branchSearchCity)
          .then(branches => {
            this.searchingForBranch = false;
            this.branches = branches;
            this.branchSearchResultVisible = true;
            this.showBranchSearch = false;

          });
    } else {
      this.realtorPortalService.findBranchByNameAndCity(this.branchSearchName,
                                                        this.branchSearchCity)
          .then(branches => {
            this.searchingForBranch = false;
            this.branches = branches;
            this.branchSearchResultVisible = true;
            this.showBranchSearch = false;
          });
    }
  }

  get passwordMatches() {
    if (!this.password) {
      return false;
    }

    if (!this.oldPassword) {
      return false;
    }

    return this.password === this.passwordConfirm;
  }

  get showPasswordMismatchIndicator() {
    return this.password && this.passwordConfirm &&
           this.password !== this.passwordConfirm;
  }

  editContactInformation() { this.selectedIndex = 1; }

  editParent() { this.selectedIndex = 2; }

  unlinkEntities() {
    this.dialogService
        .confirm(
            'Confirm',
            'Are you sure you want to unlink this real estate record from your login?')
        .subscribe(result => {
          if (result) {
            this.realtorPortalService.unlinkEntities().then(() => {
              this.entity = null;
              this.realtorPortalService.getSideBarInfo(true).then(sidebar => {

                                                                  });
            });
          }
        });
  }



  saveAgentInfo(callback: any = null) {
    this.savingAgentInfo = true;
    this.realtorPortalService.saveWebUserExInfo(this.agentInfo)
      .then((result) => {
        if (result == false) {
          this.dialogService.alert('Existing Agent', 'An agent already exists with the same license number.');
        }
          this.savingAgentInfo = false;
          this.selectedIndex = 0;
          this.refresh(callback);
          this.realtorPortalService.getSideBarInfo(true).then(() => {});
        });
  }

  changePassword() {
    this.changingPassword = true;

    this.realtorPortalService.changePassword(this.oldPassword, this.password,
                                             this.passwordConfirm)
        .then(results => {
          if (results.Success) {
            this.resetPasswordVisible = false;
            ApiAccessService.setLoginInfo(ApiAccessService.userName,
                                          this.password);
            this.snakbar.openFromComponent(ToastSuccessComponent, {
              duration: 1000,
              data: 'Password Updated',
              panelClass: ['success-toast']
            });

          } else {
            this.dialogService.alert('Could Not Change', results.Message);
          }
          this.changingPassword = false;
        });
  }
}
